import { Injectable } from '@angular/core';
import { StepImpl } from '../../models/steps/step-impl';
import { DummyStep } from '../../models/steps/dummy-step';
import { BehaviorSubject, Observable } from 'rxjs';
import { SummaryStep } from '../../models/steps/summary-step';

@Injectable({
  providedIn: 'root',
})
export class OrderingProcessService {
  private steps: StepImpl[] = [];

  private readonly currentStep = new BehaviorSubject<StepImpl>(new DummyStep());
  get $currentStep(): Observable<StepImpl> {
    return this.currentStep.asObservable();
  }

  constructor() {}

  init(steps: StepImpl[]): void {
    this.steps = steps;
    if (this.steps.length > 0) {
      this.setStep(this.steps[0]);
    }
  }

  setCurrentStep(name: string): void {
    const targetStep =
      this.steps.find((step) => step.name === name) || new DummyStep();
    const currentStep = this.getCurrentStep();
    if (!(targetStep instanceof DummyStep) && targetStep !== currentStep) {
      currentStep.isActive = false;
      this.setStep(targetStep);
    }
  }

  private setStep(step: StepImpl): void {
    step.isActive = true;
    this.currentStep.next(step);
  }

  getNextRoute(): string {
    const index = this.steps.indexOf(this.getCurrentStep());
    return this.steps[index + 1].name;
  }

  getPreviousRoute(): string {
    const index = this.steps.indexOf(this.getCurrentStep());
    return this.steps[index - 1].name;
  }

  canGoBack(): boolean {
    return this.steps.indexOf(this.getCurrentStep()) > 0;
  }

  canGoNext(): boolean {
    const currentStep = this.getCurrentStep();
    return currentStep.isReady();
  }

  isFinalStep(): boolean {
    return this.getCurrentStep() instanceof SummaryStep;
  }

  next(): void {
    const currentStep = this.getCurrentStep();
    const index = this.steps.indexOf(currentStep);
    currentStep.isActive = false;
    this.setStep(this.steps[index + 1]);
  }

  previous(): void {
    const currentStep = this.getCurrentStep();
    const index = this.steps.indexOf(currentStep);
    currentStep.isActive = false;
    this.setStep(this.steps[index - 1]);
  }

  getCurrentStep<T extends StepImpl>(): T {
    let currentStep: StepImpl = new DummyStep();
    this.currentStep.subscribe((step) => (currentStep = step)).unsubscribe();
    return currentStep as T;
  }
}
